module.exports = __webpack_public_path__ + "sketch.png?dc551081c14278ed62332731b49334c7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/sketch.png
// module id = 195
// module chunks = 0